module.exports = ".main-logo-holder{\n    top: 50%;\n    min-height: 100%;\n    margin: 70px auto;\n    text-align:center;\n    background:url(/assets/logo_nameplate.svg) no-repeat center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/product-select/product-select.component.css
// module id = ./src/app/core/components/product-select/product-select.component.css
// module chunks = main